export default __webpack_public_path__ + "static/media/doc4.131fe5c2.jpeg";